import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { newLogo } from "../../assets/Images";
import bgHomeS6 from "../../assets/landingPage/bg-home-s6.png";
import facebookIcon from "../../assets/facebook.png";
import linkedinIcon from "../../assets/linkedin.png";
import instagramIcon from "../../assets/instagram.png";
import { useReduxStore } from "../../hooks/useReduxStore.js";
import { updateHome } from "../../store/Reducers/homeReducer.js";

export default function FooterNew({ onCategoryPress }) {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const { getState, dispatch } = useReduxStore();
  const { categories } = getState("Home");

  const onItemClick = (selectedCategory) => {
    dispatch(updateHome({ selectedCategory }));
    if (onCategoryPress) {
      onCategoryPress(selectedCategory.name.toLowerCase());
    }
    navigate("/ProductCollection", { state: {} });
  };

  return (
    <footer
      className="w-full bg-black  border-t border-neutral-900 pt-16 pb-8 px-6 md:px-12 lg:px-20 font-outfit select-none bg-cover bg-center relative"
    // style={{ backgroundImage: `url(${bgHomeS6})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40 pointer-events-none"></div>

      <div className="text-white relative z-10 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
        {/* Left Column: Logo & Socials */}
        <div className="lg:col-span-1.5 flex flex-col items-center md:items-start text-center md:text-left">
          <img
            className="object-contain h-20 md:h-24 w-auto mb-4"
            src={newLogo}
            alt="BAB Logo"
          />
          {/* <span className="text-secondary font-oswald text-xs tracking-widest font-semibold uppercase mb-6">
            Boss Amongst Bosses
          </span> */}

          {/* Social media icons */}
          <div className="flex gap-4">
            <a
              href="https://www.facebook.com/profile.php?id=61567213191170"
              target="_blank"
              rel="noreferrer"
              className="p-2 bg-neutral-900/60 hover:bg-secondary/20 rounded-lg transition-colors border border-neutral-800"
            >
              <img src={facebookIcon} alt="Facebook" className="w-5 h-5 object-contain" />
            </a>
            <a
              href=""
              target="_blank"
              rel="noreferrer"
              className="p-2 bg-neutral-900/60 hover:bg-secondary/20 rounded-lg transition-colors border border-neutral-800"
            >
              <img src={linkedinIcon} alt="LinkedIn" className="w-5 h-5 object-contain" />
            </a>
            <a
              href="https://www.instagram.com/bab_media_"
              target="_blank"
              rel="noreferrer"
              className="p-2 bg-neutral-900/60 hover:bg-secondary/20 rounded-lg transition-colors border border-neutral-800"
            >
              <img src={instagramIcon} alt="Instagram" className="w-5 h-5 object-contain" />
            </a>
          </div>
        </div>

        {/* Column 2: Sub Pages */}
        <div className="text-center md:text-left">
          <h4 className="text-white font-oswald text-sm font-semibold tracking-wider uppercase mb-4">
            Sub pages
          </h4>
          <ul className="space-y-2.5 text-sm text-neutral-400 font-light">
            <li><Link to="/digital-library" className="hover:text-secondary transition-colors font-medium">Digital Library</Link></li>
            <li><Link to="/soulflow-records" className="hover:text-secondary transition-colors font-medium">Soul Flow Records</Link></li>
            <li><Link to="/news-new" className="hover:text-secondary transition-colors">Media Center</Link></li>
            <li><Link to="/mystio-new" className="hover:text-secondary transition-colors">Mystio Global Logistics</Link></li>
            <li><Link to="/About" className="hover:text-secondary transition-colors">Our Story</Link></li>
            <li><Link to="https://admin.bab-media.com/public/login" className="hover:text-secondary transition-colors">Become a Seller</Link></li>

            {/* <li><Link to="/About" className="hover:text-secondary transition-colors">What We Deliver</Link></li>
            <li><Link to="/About" className="hover:text-secondary transition-colors">Retail Revolution</Link></li>
            <li><Link to="/About" className="hover:text-secondary transition-colors">Creator Fulfillment</Link></li>
            <li><Link to="/About" className="hover:text-secondary transition-colors">Tracking Portal</Link></li>
            <li><Link to="/Contact" className="hover:text-secondary transition-colors">Delivery Partnership</Link></li> */}
          </ul>
        </div>

        {/* Column 3: Our Content */}
        <div className="text-center md:text-left">
          <h4 className="text-white font-oswald text-sm font-semibold tracking-wider uppercase mb-4">
            Our Content
          </h4>
          <ul className="space-y-2.5 text-sm text-neutral-400 font-light">
            {categories && categories.length > 0 ? (
              categories.map((cat) => (
                <li
                  key={cat.id || cat.name}
                  onClick={() => onItemClick(cat)}
                  className="hover:text-secondary transition-colors hover:cursor-pointer font-medium"
                >
                  {cat.name}
                </li>
              ))
            ) : (
              <>
                <li><Link to="/ProductCollection" className="hover:text-secondary transition-colors">E-Book</Link></li>
                <li><Link to="/ProductCollection" className="hover:text-secondary transition-colors">Music</Link></li>
                <li><Link to="/ProductCollection" className="hover:text-secondary transition-colors">Movies</Link></li>
                <li><Link to="/ProductCollection" className="hover:text-secondary transition-colors">Audio Book</Link></li>
              </>
            )}
          </ul>
        </div>

        {/* Column 4: Helpful Links */}
        <div className="text-center md:text-left">
          <h4 className="text-white font-oswald text-sm font-semibold tracking-wider uppercase mb-4">
            Helpful Links
          </h4>
          <ul className="space-y-2.5 text-sm text-neutral-400 font-light">
            <li><Link to="/FAQ" className="hover:text-secondary transition-colors">FAQs</Link></li>
            <li><Link to="/Contact" className="hover:text-secondary transition-colors">Contact</Link></li>
          </ul>
        </div>

        {/* Column 5: Contact Us */}
        <div className="text-center md:text-left">
          <h4 className="text-white font-oswald text-sm font-semibold tracking-wider uppercase mb-4">
            Contact Us
          </h4>
          <ul className="space-y-2.5 text-sm text-neutral-400 font-light">
            <li>
              <a href="mailto:babmedia2023@gmail.com" className="hover:text-secondary transition-colors">
                babmedia2023@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:7027430250" className="hover:text-secondary transition-colors">
                609-773-9620
              </a>
            </li>
            <li className="leading-relaxed">
              Atlantic City, NJ 08401
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Row */}
      <div className="relative text-white z-10 max-w-6xl mx-auto border-t border-neutral-900 pt-8 flex flex-col sm:flex-row items-center justify-between text-neutral-500 text-xs sm:text-sm gap-4">
        <div>
          © {currentYear} Boss Amongst Bosses
        </div>
        <div className="flex gap-4">
          <span>All rights reserved.</span>
          <Link to="/TermsCondition" className="text-secondary underline hover:text-secondary/80">
            Terms & Condition
          </Link>
          <Link to="/Policy" className="text-secondary underline hover:text-secondary/80">
            Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
